import { useMutation, useQuery } from '@tanstack/react-query'

import { useToast } from '@/shared/contexts/ToastContext'

import {
  patchNutritionIntake,
  recomputeNutritionIntake,
  searchNutritionFoods,
  type NutritionIntakeOp,
} from './api'
import {
  nutritionReportWriteScope,
  useReplaceNutritionReport,
} from './useNutritionReport'

// 食事の欄から計算し直す (同期で 10〜20 秒)。人が直した食品と g も含めて置き換わる。応答 (報告書の全体) で手元を
// 差し替える。栄養価の数字は back が成分表から出す (画面では計算しない)。
export const useRecomputeNutritionIntake = (eventId: string) => {
  const { beforeWrite, replace } = useReplaceNutritionReport(eventId)
  const { showToast } = useToast()
  return useMutation({
    scope: nutritionReportWriteScope(eventId),
    mutationFn: () => recomputeNutritionIntake(eventId),
    onMutate: beforeWrite,
    onSuccess: replace,
    onError: () => showToast('栄養価を計算できませんでした', 'error'),
  })
}

// 人の 1 手 (材料の食品と g・足す・消す)。位置 (path) で送るので、同じ記録への手は直列にする。
export const useEditNutritionIntake = (eventId: string) => {
  const { beforeWrite, replace } = useReplaceNutritionReport(eventId)
  const { showToast } = useToast()
  return useMutation({
    scope: nutritionReportWriteScope(eventId),
    mutationFn: (op: NutritionIntakeOp) => patchNutritionIntake(eventId, op),
    onMutate: beforeWrite,
    onSuccess: replace,
    onError: () => showToast('栄養価を保存できませんでした', 'error'),
  })
}

// 成分表の食品を似た名前で引く (材料の欄の候補)。成分表は変わらないので長く持つ。
export const useNutritionFoods = (q: string) =>
  useQuery({
    queryKey: ['nutritionFoods', q],
    queryFn: () => searchNutritionFoods(q),
    enabled: q.trim().length > 0,
    staleTime: 1000 * 60 * 60,
  })
